import { safeLookup } from '@splunk/olly-utilities/lib/sfUtilities/sfUtilities';
import { colorAccessibilityOptions } from '@splunk/olly-services/lib/services/ColorAccessibility/colorAccessibilityOptions';

angular.module('signalview.detector.wizard').service('detectorWizardMessageHandlebarService', [
    'APP_URL',
    'detectorUtils',
    '_',
    'moment',
    'valueFormatter',
    'plotUtils',
    'featureEnabled',
    function (APP_URL, detectorUtils, _, moment, valueFormatter, plotUtils, featureEnabled) {
        const INPUTS_REGEX = /{{2,}[^\S\n]*(?:inputs|displayInputs)\.([\w]+)\.value[^\S\n]*}{2,}/;
        const FAKE_INPUT_VALUE = {
            value: '9.99', // design decision to default to a random number that looks real
        };

        function formatValueWithUnit(value, unitType, prefix, suffix) {
            if (unitType) return valueFormatter.formatScalingUnit(Number(value), unitType);
            if (prefix || suffix) return (prefix || '') + String(value) + (suffix || '');
            return String(value);
        }

        function getPlotUnitConfig(plotLetter, plots) {
            const plot = plotUtils.getPlotByKey(plotLetter, plots);
            return {
                unitType: safeLookup(plot, 'configuration.unitType'),
                prefix: safeLookup(plot, 'configuration.prefix') || '',
                suffix: safeLookup(plot, 'configuration.suffix') || '',
            };
        }

        function getUnitTypeForPlot(plotLetter, plots) {
            return getPlotUnitConfig(plotLetter, plots).unitType;
        }

        function getContextObject(detector, rule) {
            const severity = rule.severityLevel || rule.severity;
            const plots = safeLookup(detector, 'sf_uiModel.allPlots') || [];
            const detectorId = detector.sf_id || detector.id;
            const params = {
                detectorId: detectorId || 'NEW_DETECTOR_ID',
                detectorName: detector.sf_detector || detector.name || 'Untitled Detector',
                detectorUrl: detectorId ? APP_URL + '#/detector/' + detectorId : 'URL',
                ruleName: rule.name || rule.detectLabel || 'Untitled Rule',
                ruleSeverity: severity,
                ruleSeverityColor:
                    colorAccessibilityOptions.default.alertColors[severity.toLowerCase()],
                readableRule:
                    rule.readable ||
                    rule.description ||
                    detectorUtils.getAutoDetectorRuleDescription(rule, plots, true),
                runbookUrl: rule.runbookUrl,
                tip: rule.tip,
                incidentId: 'DI_FNDRAEAE',
                timestamp: moment(),
                detectorOnCondition: '', // do not need for now
                detectorOffCondition: '', // do not need for now
                anomalyState: 'ANOMALOUS',
                imageUrl: 'http://your-preview-image-url.goes-here.com',
                normal: false,
                anomalous: true,
                manuallyResolved: false,
                detectorStopped: false,
                organizationId: detector.sf_organizationID,
            };

            params.inputs = {};
            params.displayInputs = {};
            const showUnits = featureEnabled('alertMessageShowUnits');
            const message = detectorUtils.getAutoDetectorRuleParameterizedString(rule, plots, true);
            setInputsFromMessage(params, message, plots, showUnits);

            return params;
        }

        function setInputsFromMessage(params, message, plots, showUnits) {
            const variables = getInputVariables(message);
            variables.forEach((variable) => {
                params.inputs[variable] = FAKE_INPUT_VALUE;
                if (showUnits) {
                    const { unitType, prefix, suffix } = getPlotUnitConfig(variable, plots);
                    params.displayInputs[variable] = {
                        value: formatValueWithUnit(
                            FAKE_INPUT_VALUE.value,
                            unitType,
                            prefix,
                            suffix
                        ),
                    };
                }
            });
        }

        function getInputVariables(message) {
            let match = message.match(INPUTS_REGEX);
            const descriptions = [];
            while (match !== null) {
                descriptions.push(match[1]);

                message = message.replace(INPUTS_REGEX, '');
                match = message.match(INPUTS_REGEX);
            }

            return _.uniq(descriptions);
        }

        return {
            getContextObject,
            getInputVariables,
            formatValueWithUnit,
            getUnitTypeForPlot,
            getPlotUnitConfig,
            FAKE_INPUT_VALUE,
        };
    },
]);
